module.exports = __webpack_public_path__ + "Employer Notice 08_19_2024_1.pdf";